<template>
	<div>
		<div class="first_line">
			<el-button type="primary" size="small" @click="addstore">新建门店</el-button>
			<div class="right_warp">
				开业时间:
				<el-date-picker style="width:380px;margin-left: 5px" size="small" v-model="times" type="datetimerange"
					range-separator="至" start-placeholder="开始日期" value-format="yyyy-MM-dd HH:mm:ss"
					end-placeholder="结束日期">
				</el-date-picker>
				<!-- 选择状态 -->
				<el-select class="jul" size="small" v-model="stateVal" placeholder="状态">
					<el-option v-for="item in statelist" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-input size="small" style="text-align: left" @keydown.enter.native="screen()" class="jul"
					placeholder="请输入店铺名称" v-model="storeName" clearable>
				</el-input>
				<el-button class="jul" type="primary" size="small" @click="screen()">筛选</el-button>
			</div>
		</div>
		<el-tabs>
			<el-tab-pane label="营业门店">
				<div>
					<el-table :cell-style="{'text-align':'center'}"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
						:data="tableData" tooltip-effect="dark" style="width: 100%">
						<!-- <el-table-column
								label="选择"
								type="selection"
								width="55">
						    </el-table-column> -->
						<el-table-column prop="id" width="80" label="门店ID"></el-table-column>
						<el-table-column prop="title" label="门店名称" width="200"></el-table-column>
						<el-table-column prop="address" label="门店地址"></el-table-column>
						<el-table-column prop="price" label="显示价钱">
							<template slot-scope="scope">
								<div style="font-weight: 800; font-size: 14px;">
									￥{{scope.row.price}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="isMember" label="业绩计算">
							<template slot-scope="scope">
								<div>
									{{scope.row.isMember==0?"常规":"实收"}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="type" width="80" label="店铺属性">
							<template slot-scope="scope">
								<div v-if="scope.row.type!=6">
									{{ scope.row.type==1?"直营店":""}}
									{{ scope.row.type==2?"合作店":""}}
									{{ scope.row.type==5?"地铁店":""}}
								</div>
								<div v-else style="color: red;">
									{{ scope.row.type==6?"加盟店":""}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="storeType" label="店铺类型">
							<template slot-scope="scope">
								<div>
									{{scope.row.storeType=='1'?"单剪店":(scope.row.storeType=='2'?"染护店":'/')}}
								</div>
							</template>
						</el-table-column>
            <el-table-column prop="storeType" label="所属平台">
              <template slot-scope="scope">
                <div>
                  {{scope.row.platform===1?"潮剪":"芭曲"}}
                </div>
              </template>
            </el-table-column>
<!--						<el-table-column prop="isDist" label="是否参与用户分销">-->
<!--							<template slot-scope="scope">-->
<!--								<div>-->
<!--									{{scope.row.isDist==0?"否":"是"}}-->
<!--								</div>-->
<!--							</template>-->
<!--						</el-table-column>-->
						<el-table-column prop="store" width="80" label="门店店长"></el-table-column>
						<el-table-column width="80" label="员工数量">
							<template slot-scope="scope">
								{{ scope.row.workerNum}}
							</template>
						</el-table-column>
						<el-table-column prop="tag" label="门店标识" width="150"></el-table-column>
						<el-table-column label="开业时间" width="150px">
							<template slot-scope="scope">
								{{ scope.row.addTime?scope.row.addTime:"无"}}
							</template>
						</el-table-column>
						<el-table-column width="80" label="状态">
							<template slot-scope="scope">
								<div>
									{{scope.row.businessType==0?"上架":"下架"}}
								</div>
								{{ scope.row.state==1?"正常营业":""}}
								{{ scope.row.state==2?"门店撤店":""}}
								{{ scope.row.state==3?"即将开业":""}}
								{{ scope.row.state==4?"门店调休":""}}
								{{ scope.row.state==5?"暂停营业":""}}
								{{ scope.row.state==6?"升级装修中":""}}
							</template>
						</el-table-column>
						<el-table-column width="200" label="操作">
							<template slot-scope="scope">
                <el-button type="text" @click="deit(scope.row.id)">编辑</el-button>
                <el-button type="text" @click="storedown(scope.row.id,scope.row.businessType)">
                  {{scope.row.businessType==0?"下架":"上架"}}
                </el-button>
                <!-- <el-button type="text" @click="details(scope.row.id)">详情</el-button> -->
                <!--<el-button type="text" @click="openYouhui(scope.row)">优惠</el-button>-->
                <el-button type="text" v-if="scope.row.businessType==0"
                  @click="hiddenordel(scope.row.id,4,scope.row.isHidden)"><span
                    v-if="scope.row.isHidden==0">隐藏</span><span
                    v-if="scope.row.isHidden==1">显示</span>
                </el-button>
                <el-button type="text" v-if="scope.row.businessType==1"
                  @click="hiddenordel(scope.row.id,3)"><span
                    style="color: red;">删除</span></el-button>
                <el-button type="text" @click="handleQrcode(scope.row.id)">二维码</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagescg">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="pagesize.page" :page-sizes="[10, 15, 20,30,50]" :page-size="pagesize.size"
							layout="total" :total="tableData.length">
						</el-pagination>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="结业门店">
				<div>
					<el-table :cell-style="{'text-align':'center'}"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
						:data="closeStore" tooltip-effect="dark" style="width: 100%">
						<!-- <el-table-column
								label="选择"
								type="selection"
								width="55">
						    </el-table-column> -->
						<el-table-column prop="id" width="80" label="门店ID"></el-table-column>
						<el-table-column prop="title" label="门店名称" width="200px"></el-table-column>
						<el-table-column prop="address" label="门店地址"></el-table-column>
						<el-table-column prop="price" label="显示价钱">
							<template slot-scope="scope">
								<div style="font-weight: 800; font-size: 14px;">
									￥{{scope.row.price}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="isMember" label="业绩计算">
							<template slot-scope="scope">
								<div>
									{{scope.row.isMember=="0"?"常规":"实收"}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="type" width="80" label="店铺属性">
							<template slot-scope="scope">
								<div v-if="scope.row.type!=6">
									{{ scope.row.type==1?"直营店":""}}
									{{ scope.row.type==2?"合作店":""}}
									{{ scope.row.type==5?"地铁店":""}}
								</div>
								<div v-else style="color: red;">
									{{ scope.row.type==6?"加盟店":""}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="storeType" label="店铺类型">
							<template slot-scope="scope">
								<div>
									{{scope.row.storeType=='1'?"单剪店":(scope.row.storeType=='2'?"染护店":'/')}}
								</div>
							</template>
						</el-table-column>
<!--						<el-table-column prop="isDist" label="是否参与用户分销">-->
<!--							<template slot-scope="scope">-->
<!--								<div>-->
<!--									{{scope.row.isDist==0?"否":"是"}}-->
<!--								</div>-->
<!--							</template>-->
<!--						</el-table-column>-->
						<el-table-column prop="store" width="80" label="门店店长"></el-table-column>
<!--						<el-table-column label="联系方式" width="150px">-->
<!--							<template slot-scope="scope">-->
<!--								{{ scope.row.telphone?scope.row.telphone:"无"}}-->
<!--							</template>-->
<!--						</el-table-column>-->
<!--						<el-table-column prop="firstMoney" label="成人首次消费价格">-->
<!--							<template slot-scope="scope">-->
<!--								{{(scope.row.firstMoney/100).toFixed(2)}}-->
<!--							</template>-->
<!--						</el-table-column>-->
<!--						<el-table-column prop="childMoney" label="儿童首次消费价格">-->
<!--							<template slot-scope="scope">-->
<!--								{{(scope.row.childMoney/100).toFixed(2)}}-->
<!--							</template>-->
<!--						</el-table-column>-->
						<el-table-column width="80" label="员工数量">
							<template slot-scope="scope">
								{{ scope.row.workerNum}}
							</template>
						</el-table-column>
						<el-table-column prop="tag" label="门店标识" width="150px">
						</el-table-column>
						<el-table-column label="开业时间" width="150px">
							<template slot-scope="scope">
								{{ scope.row.addTime?scope.row.addTime:"无"}}
							</template>
						</el-table-column>
						<el-table-column width="80" label="状态">
							<template slot-scope="scope">
								<div>
									{{scope.row.businessType==0?"上架":"下架"}}
								</div>
								{{ scope.row.state==1?"正常营业":""}}
								{{ scope.row.state==2?"门店撤店":""}}
								{{ scope.row.state==3?"即将开业":""}}
								{{ scope.row.state==4?"门店调休":""}}
								{{ scope.row.state==5?"暂停营业":""}}
								{{ scope.row.state==6?"升级装修中":""}}
							</template>
						</el-table-column>
						<el-table-column width="200" label="操作">
							<template slot-scope="scope">
                <el-button type="text" @click="deit(scope.row.id)">编辑</el-button>
                <el-button type="text" @click="storedown(scope.row.id,scope.row.businessType)">
                  {{scope.row.businessType==0?"下架":"上架"}}
                </el-button>
                <!-- <el-button type="text" @click="details(scope.row.id)">详情</el-button> -->
                <!--<el-button type="text" @click="openYouhui(scope.row)">优惠</el-button>-->
                <el-button type="text" v-if="scope.row.businessType==0"
                  @click="hiddenordel(scope.row.id,4,scope.row.isHidden)"><span
                    v-if="scope.row.isHidden==0">隐藏</span><span
                    v-if="scope.row.isHidden==1">显示</span>
                </el-button>
                <el-button type="text" v-if="scope.row.businessType==1"
                  @click="hiddenordel(scope.row.id,3)"><span
                    style="color: red;">删除</span></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagescg">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="pagesize.page" :page-sizes="[10, 15, 20,30,50]" :page-size="pagesize.size"
              layout="total" :total="closeStore.length">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 首单优惠 -->
		<el-dialog :visible.sync="dialog_youhui" title="门店首单优惠" width="40%">
			<div style="display: flex;float: right;margin-top: -65px;margin-right: 50px;">
				<span>是否上架</span>
				<span>
					<el-switch v-model="sendData.first"></el-switch>
				</span>
			</div>
      <el-row :gutter="20">
        <el-col :span="12">
          成人首单剪发优惠<el-input-number v-model="sendData.firstMoney" size="mini" :precision="2" style="margin: 0 0 10px 10px">
        </el-input-number> 元
        </el-col>
        <el-col :span="12">
          儿童首单剪发优惠<el-input-number v-model="sendData.childMoney" size="mini" :precision="2" style="margin: 0 0 10px 10px">
        </el-input-number> 元
        </el-col>
        <el-col :span="12">
          女士首单剪发优惠<el-input-number v-model="sendData.womanMoney" size="mini" :precision="2" style="margin: 0 0 10px 10px">
        </el-input-number> 元
        </el-col>
        <el-col :span="12">
          男士首单剪发优惠<el-input-number v-model="sendData.manMoney" size="mini" :precision="2" style="margin: 0 0 10px 10px">
        </el-input-number> 元
        </el-col>
      </el-row>
			<div style="margin-top: 5%;">
				可使用时间
				<span>
					<el-switch v-model="checkAll" inactive-text="全不选" active-text="全选" @change="handleCheckAllChange">
					</el-switch>
				</span>
			</div>
			<el-checkbox-group v-model="sendData.firstDay" multiple="" style="margin-top: 1%;">
				<el-checkbox v-for="item in dayList" :label="item.id">{{item.name}}</el-checkbox>
			</el-checkbox-group>
			<div slot="footer" style="text-align: center;">
				<el-button @click="cancel()">取消</el-button>
				<el-button @click="saveFirst()" type="primary">确定</el-button>
			</div>
		</el-dialog>
    <!-- 二维码对话框 -->
    <el-dialog title="门店二维码" :visible.sync="openQrcode" width="800px">
      <div class="qrcode" ref="qrcodeRef">
        <img :src="qrcodeForm.qrcode"
             alt="无法显示"
             width="400"
             height="400" />
      </div>
      <template #footer>
        <div class="" style="text-align: center">
          <el-button type="primary" @click="handleDownload">下载</el-button>
          <el-button @click="openQrcode = false">取 消</el-button>
        </div>
      </template>
    </el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
        openQrcode: false,
				dialog_youhui: false,
				sendData: {
					first: false,
					firstMoney: 0,
					childMoney:0,
          womanMoney:0,
          manMoney:0,
					firstDay: [],
				},
				checkAll: false, //全选首单优惠时间
				isIndeterminate: true,
				store: {},
				//新建门店
				form: {},
				// 新建门店弹出框是否显示
				pagesize: {
					size: 99,
					page: 1,
					total: 100
				},
				tableData: [],
				closeStore: [],
				// tabs 数据列表
				tabs: [{
					id: 0,
					value: "门店管理",
					isActive: true,
				}, {
					id: 1,
					value: "加盟管理",
					isActive: false,
				}, {
					id: 2,
					value: "门店指标",
					isActive: false,
				}, ],
				//   tabs门店管理
				// 开业时间
				times: ["", ""],
				// 选择门店
				timeVal: "",
				// 选择状态
				stateVal: "",
				statelist: [{
					label: "正常营业",
					value: 1,
				}, {
					label: "门店撤店",
					value: 2,
				}, {
					label: "即将开业",
					value: 3,
				}, {
					label: "门店调休",
					value: 4,
				}, {
					label: "暂停营业",
					value: 5,
				}, {
					label: "升级装修中",
					value: 6,
				}, ],
				dayList: [{
					id: "1",
					name: '周一'
				}, {
					id: "2",
					name: '周二'
				}, {
					id: "3",
					name: '周三'
				}, {
					id: "4",
					name: '周四'
				}, {
					id: "5",
					name: '周五'
				}, {
					id: "6",
					name: '周六'
				}, {
					id: "7",
					name: '周日'
				}, ],
				// 店铺名称
				storeName: "",
				currentPage4: 4,
        // 二维码
        qrcodeForm: {
          qrcode: '',
          storeId: ''
        }
			};
		},
		mounted() {
			this.getlist()
		},
		methods: {
			// 添加门店
			addstore(store) {
				this.$router.push({
					path: `/storeDetail2`,
				})
			},
			// 编辑门店
			deit(store) {
				this.$router.push({
					path: `/storeDetail2?id=` + store,
				})
			},
			// 查看门店详情
			details(id) {
				this.$router.push({
					path: `/storeDetail?id=` + id,
				})
			},
			// 获取门店列表
			getlist() {
				if (this.times) {
					var time1 = this.times[0]
					var time2 = this.times[1]
				} else {
					var time1 = ""
					var time2 = ""
				}
				this.$http.get("store/list?title=" + this.storeName + "&page=" + this.pagesize.page + "&size=" + this
					.pagesize.size + "&startTime=" + time1 + "&endTime=" + time2 + "&state=" + this.stateVal).then(
					function(res) {
						if (res.body.code == "200") {
							this.pagesize.total = res.body.data.total
							this.tableData = res.body.data.rows.filter(ele => ele.state == 1)
							this.closeStore = res.body.data.rows.filter(ele => ele.state >= 2)
						} else {
							this.$message.error("请求失败")
						}
					},
					function(err) {
						this.$message.error("请求失败")
					})
			},
			// 门店下架
			storedown(id, businessType) {
				if (businessType == 0) {
					var type = 1
				} else {
					var type = 0
				}
				this.$http.get("store/type?id=" + id + "&type=" + type).then(function(res) {
					if (res.body.code == "200") {
						this.getlist()
						if (businessType == 0) {
							this.$message.success("下架成功")
						} else {
							this.$message.success("上架成功")
						}
					} else {
						this.$message.error(res.body.msg)
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			hiddenordel(id, type, ishidden) {
				if (type == 3) {
					this.$confirm('是否删除该门店?删除门店会造成数据流失，请谨慎操作！', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$http.get("store/type?id=" + id + "&type=" + type).then(function(res) {
							if (res.body.code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.getlist()
							} else {
								this.$message.error(res.body.msg);
							}
						})
					}).catch(() => {

					});
				} else {
					this.$http.get("store/type?id=" + id + "&type=" + type).then(function(res) {
						if (res.body.code == "200") {
							if (ishidden == 0) {
								this.$message.success("隐藏成功")
							} else {
								this.$message.success("显示成功")
							}
							this.getlist()
						} else {
							this.$message.error(res.body.msg)
						}
					})
				}
			},
			getFirst(id) {
				this.sendData.first = false
				this.sendData.firstMoney = 0
				this.sendData.childMoney = 0
        this.sendData.womanMoney = 0
        this.sendData.manMoney = 0
				this.sendData.firstDay = []
				this.checkAll = false
				this.$http.get("store/getFirst?id=" + id).then(res => {
					var r = res.body.data
					this.sendData.id = r.id
					this.sendData.first = r.first
					if (r.firstDay != null) {
						if (r.firstDay.indexOf(",") != -1) {
							this.sendData.firstDay = r.firstDay.split(",")
						}
						if (this.sendData.firstDay.length == 7) {
							this.checkAll = true
						}
					}
					this.sendData.firstMoney = r.firstMoney / 100
					this.sendData.childMoney = r.childMoney / 100
          this.sendData.womanMoney = r.womanMoney / 100
          this.sendData.manMoney = r.manMoney / 100
				})
			},
			saveFirst() {
				this.sendData.firstMoney = (this.sendData.firstMoney * 100).toFixed()
				this.sendData.childMoney = (this.sendData.childMoney * 100).toFixed()
        this.sendData.womanMoney = (this.sendData.womanMoney * 100).toFixed()
        this.sendData.manMoney = (this.sendData.manMoney * 100).toFixed()
				if (this.sendData.firstDay.length == 1) {
					this.sendData.firstDay = this.sendData.firstDay[0]
				}
				if (this.sendData.firstDay.length > 1) {
					this.sendData.firstDay = this.sendData.firstDay.join(",")
				}
				if (this.sendData.firstDay.length == 0) {
					this.sendData.firstDay = null
				}
				this.$http.post("store/saveFirst", JSON.stringify(this.sendData)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功!")
						this.getlist()
					}
				})
				this.dialog_youhui = false
			},
			cancel() {
				this.dialog_youhui = false;
				this.checkAll = false
				this.sendData = []
			},
			// 门店筛选
			screen() {
				this.getlist()
			},
			handleCheckAllChange() {
				if (this.checkAll) {
					this.sendData.firstDay = []
					this.dayList.forEach(item => {
						this.sendData.firstDay.push(item.id);
					})
				} else {
					this.sendData.firstDay = []
				}
			},
			handleSizeChange(val) {
				this.pagesize.size = val
				this.getlist()
			},
			handleCurrentChange(val) {
				this.pagesize.page = val
				this.getlist()
			},
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
      handleQrcode(id) {
        this.qrcodeForm = {}
        this.openQrcode = true;
        this.$http.get("store/" + id + "/qrcode").then(
            function(res) {
              if (res.body.code == "200") {
                console.log("二维码数据", res.body.data)
                this.qrcodeForm = res.body.data
              } else {
                this.$message.error("请求失败")
              }
            },
            function(err) {
              this.$message.error("请求失败")
            })
      },
      handleDownload() {
        const imageUrl = this.qrcodeForm.qrcode; // 假设这里存储的是图片的URL
        const outputFilename = 'qrcode_' + this.qrcodeForm.storeId + '.png';
        this.downloadImageFile(imageUrl, outputFilename);
      },
      downloadImageFile(url, filename) {
        fetch(url)
            .then(response => response.blob()) // 获取资源并转换为blob
            .then(blob => {
              const link = document.createElement('a'); // 创建一个 a 元素
              const url = window.URL.createObjectURL(blob); // 创建一个临时的URL代表Blob对象
              link.href = url;
              link.download = filename; // 设置下载文件名
              document.body.appendChild(link); // 将 a 元素添加到 DOM 中
              link.click(); // 触发点击事件，开始下载
              document.body.removeChild(link); // 下载完成后，移除 a 元素
              window.URL.revokeObjectURL(url); // 释放之前创建的 URL 对象
            })
            .catch(console.error); // 错误处理
      }
      // handleDownload() {
      //   const base64Data = 'data:image/jpg;base64,' + this.qrcodeForm.qrcode;
      //   const outputFilename = 'qrcode_' + this.qrcodeForm.storeId + '.png';
      //   this.downloadBase64File(base64Data, outputFilename);
      // },
      // downloadBase64File(base64, filename) {
      //   // 创建一个 a 元素
      //   const link = document.createElement('a');
      //   // 设置 a 元素的 href 属性为 base64 数据
      //   link.href = base64;
      //   // 设置 download 属性，指定下载文件名
      //   link.download = filename;
      //   // 将 a 元素添加到 DOM 中
      //   document.body.appendChild(link);
      //   // 触发点击事件，开始下载
      //   link.click();
      //   // 下载完成后，移除 a 元素
      //   document.body.removeChild(link);
      // },
		},
	};
</script>
<style lang="less" scoped>
	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.dialog-footer {
		display: inline-block;
		margin-right: 31%;
	}

	// 弹出框内容
	.dia_title {
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #525252;
	}

	.erwei {
		width: 157px;
		height: 157px;
		margin: 20px auto;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.downerwei {
		cursor: pointer;
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #409EFF;
	}

	.dialog-footer {
		margin-top: -10px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

  .qrcode {
    text-align: center;
  }
</style>
